import { LabelValuePair, TeamMember } from "types";

export type CommentActionItem = boolean;
export type CommentBadgeNumber = string;
export interface Comment {
  actionItem: CommentActionItem;
  badgeNumber?: CommentBadgeNumber;
  createdDate: Date;
  hidden: boolean; // Hidden from client
  id: string;
  open?: boolean;
  replyCount: number;
  text: string; // Comment text
  user: Partial<TeamMember>;
  /** Touchpoint version number (e.g. batch version) for the version this comment belongs to */
  version?: number;
  /** Touchpoint version id for the version this comment belongs to */
  versionId?: string;
  annotationId?: string;
}

export interface CommentFilterOption extends LabelValuePair {
  id: string;
}

export interface CommentsSummary {
  commentCount: number;
  actionItemCount: number;
  hiddenCount: number;
  openCount: number;
}

export interface NewComment {
  text: string;
  actionItem?: boolean;
  hidden?: boolean;
  parentId?: string;
  annotationId?: string;
}

export interface CommentReply {
  id?: string;
  user: Partial<TeamMember>;
  text: string; // Comment text
  createdDate: Date;
  parentCommentId: string;
}

export const emptyCommentSummary: CommentsSummary = {
  commentCount: 0,
  actionItemCount: 0,
  hiddenCount: 0,
  openCount: 0,
};

export const commentFilterOptions: CommentFilterOption[] = [
  {
    id: "open-comments",
    label: "Open comments",
    value: "open=true",
  },
  {
    id: "action-items-only",
    label: "Action items only",
    value: "actionItem=true",
  },
  {
    id: "closed-only",
    label: "Closed only",
    value: "open=false",
  },
  {
    id: "visible-to-client-only",
    label: "Visible to client only",
    value: "hidden=false",
  },
  {
    id: "all-comment-history",
    label: "All comment history",
    value: "",
  },
] as const;
